module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-extra-fields"
  }, [_c('h2', [_vm._v("Extra")]), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.fields), function(value, label) {
    return _c('div', {
      staticClass: "columns"
    }, [_c('label', [_vm._v(_vm._s(label)), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.fields[label]),
        expression: "fields[label]"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.fields[label])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.fields, label, $event.target.value)
        }
      }
    })])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-487dfc84!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/ClientExtraFields.vue
// module id = 2466
// module chunks = 1